module.exports = "<div #reportContainer style=\"width: 100%; height: 600px;\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/power-bireport/power-bireport.component.html
// module id = ./src/app/shared-components/power-bireport/power-bireport.component.html
// module chunks = main